import { Skeleton } from "@mui/material";
import React from "react";

const HeaderSkeleton = () => {
  return <Skeleton sx={{ width: "100%" }} height={100} />;
};

export default HeaderSkeleton;
